import { render, staticRenderFns } from "./ModernLayout.vue?vue&type=template&id=79e024a6&scoped=true"
import script from "./ModernLayout.vue?vue&type=script&lang=js"
export * from "./ModernLayout.vue?vue&type=script&lang=js"
import style0 from "./ModernLayout.vue?vue&type=style&index=0&id=79e024a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e024a6",
  null
  
)

export default component.exports